import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { ShowPagination, TableComponent } from "@serpro/ngx-suite-rfb";

export enum ColunaCustomizada {
  EXPANDIR = 'expandir',
}

export const COLUNA_PADRAO = {
  cellClass: "flex centralizar",
  headerClass: "flex centralizar",
  filterable: true,
  resizeable: false,
};

export const COLUNA_ACAO = {
  cellClass: "flex centralizar",
  headerClass: "flex centralizar coluna-simples",
  filterable: false,
  hideable: false,
  exportable: false,
  sortable: false,
};

@Component({
  selector: 'via-suite-rfb-table',
  templateUrl: './via-suite-rfb-table.component.html',
  styleUrls: ['./via-suite-rfb-table.component.css'],
})
export class ViaSuiteRfbTableComponent extends TableComponent implements OnInit, OnChanges {
  @Input() public exibirFiltros: boolean = false;
  @Input() public showPagination: ShowPagination = "bottom";
  @Input() public showFiltersStats: boolean = false;
  @Input() public scrollbarH: boolean = false;
  @Input() public footerHeight: number = 65;

  @ViewChild("tabela") public tabela: TableComponent;

  public ngOnInit(): void {
    super.ngOnInit();

    this.moverColunaExpandirDetalhes();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    this.moverColunaExpandirDetalhes();
  }

  public get defaultFooterText(): string {
    return `Total: ${this.rows?.length ?? 0} registro(s)`;
  }

  private moverColunaExpandirDetalhes(): void {
    const columns = this.tabela?.dtcolumns;

    if (this.detailTemplate && columns?.length > 0) {
      // Move a coluna de expandir e contrair detalhes nativo do componente {TableComponent} da biblioteca {ngx-suite-rfb}
      // Substituindo a coluna customizada { name: ColunaCustomizada.EXPANDIR }
      const expandirIndex = columns.findIndex((column) => column.name === ColunaCustomizada.EXPANDIR);
      const column = expandirIndex !== -1 ? columns.splice(0, 1)[0] : columns[0];

      column.headerClass = "flex centralizar coluna-simples";
      column.cellClass = "flex centralizar";
      column.maxWidth = 34;

      if (expandirIndex !== -1) {
        columns[expandirIndex - 1] = column;
      }
    }
  }

  public isRowExpanded(row: any): boolean {
    return this.tabela?.ngxtable?.bodyComponent.getRowExpanded(row) ?? false;
  }

  public toggleExpandRow(row: any, status: boolean) {
    this.tabela?.toggleExpandRow(row, status);
  }
}